import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkin-code-add",
  "use": "icon-checkin-code-add-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-checkin-code-add\">\r\n    <defs>\r\n        <style>#icon-checkin-code-add .a{fill:#0062FF;}#icon-checkin-code-add .b{fill:#fff;}</style>\r\n    </defs>\r\n    <circle class=\"a\" cx=\"10\" cy=\"10\" r=\"10\" />\r\n    <path class=\"b\" d=\"M3,8V5H0V3H3V0H5V3H8V5H5V8Z\" transform=\"translate(6 6)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/checkin-code-add.svg
// module id = HMKW
// module chunks = 115